import { render, staticRenderFns } from "./UserView.vue?vue&type=template&id=11b0809b&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"
import style0 from "./UserView.vue?vue&type=style&index=0&id=11b0809b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b0809b",
  null
  
)

export default component.exports